<template>
  <h-dialog title="查看视频" v-model="visible" :footer="false" @onCancel="onCancel" width="850">
    <div style="width: 800px;height: 450px">
      <video style="width: 100%; height: 100%; object-fit: scale-down" ref="videoPlayer" :src="options.src" controls></video>
    </div>
  </h-dialog>
</template>

<script setup>

import { reactive, ref } from "vue";

const visible = ref(false)

const options = ref({
  src: "", //视频源
});


function show(_options) {
  options.value = {
    ..._options
  }
  visible.value = true
}
function onCancel() {
  visible.value = false
}

defineExpose({
  show
})
</script>

<style lang="scss" scoped>
.video-modal {
  background: #000 !important;
}
</style>